<template>
  <div class="search__field">
    <!-- Search field -->
    <Input
      id="search-input"
      ref="searchField"
      name="search__field"
      :placeholder="placeholder"
      :value="keyword"
      type="search"
      autocomplete="off"
      :disabled="disabled"
      @keydown="handleKeyDown"
      @change="onInput"
      @blur="handleBlur"
      @focus="handleFocus"
    />
    <!-- Results -->
    <div v-if="showSuggestions && results.length > 0" class="search__results">
      <div class="search__results__spacer"></div>
      <div
        v-for="(result, index) in results"
        :key="index"
        :class="activeClass(index)"
        class="search__results__entry"
        @click.prevent.stop="select(result)"
      >
        <slot name="result" :result="result">
          {{ result.name }}
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import Vue, { defineComponent } from "vue";

export default defineComponent({
  name: "Search",
  hideFromDocs: true,
  status: "prototype",
  release: "0.0.1",
  props: {
    // eslint-disable-next-line vue/require-default-prop
    placeholder: String,
    // eslint-disable-next-line vue/require-default-prop
    keyword: String,
    results: { type: Array, default: () => [] },
    debounce: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    minChars: { type: Number, default: 1 },
    debounceMs: {
      type: Number,
      default: 500,
    },
  },
  data() {
    return {
      focus: -1,
      selection: "",
      showSuggestions: false,
    };
  },
  watch: {
    results(newVal) {
      this.results = newVal;
      this.showSuggestions =
        this.results.length > 1 || this.results.some((it) => it.name !== this.selection);
    },
  },
  methods: {
    select(result) {
      this.showSuggestions = false;
      this.selection = result.name;
      this.$emit("select", result);
      this.reset();
    },
    handleBlur() {
      // Hide a bit later so selections can take place if
      // user has selected entry and it has caused onBlur
      setTimeout(() => {
        this.reset();
      }, 250);
    },
    handleKeyDown(keyword) {
      this.$emit("keydown", keyword);
    },
    onInput(keyword) {
      this.selection = "";
      this.$emit("search", keyword.trim());
      /* FIXME: To use min characters for a search, we also need to handle emptying the keyword. */
      //if (keyword.length >= this.minChars) {
      //}
    },
    reset() {
      this.focus = -1;
      this.showSuggestions = false;
    },
    activeClass(index) {
      return index === this.focus ? "search__results__active" : "";
    },
    handleFocus() {
      this.focus = -1;
    },
  },
});
</script>

<style lang="scss">
@import "../../design-system/assets/tokens/tokens";
.search__field {
  position: relative;
  margin-bottom: $space-m;
  .search__results {
    font-size: 14px;
    background-color: #fff;
    outline: 0;
    box-shadow: 0 2px 4px 0 $input-border-color;
    width: 100%;
    max-width: 400px;
    position: absolute;
    top: 36px;
    z-index: $z-index-sticky;
    border: 1px solid $input-border-color;
    border-top: 0;
    border-bottom-left-radius: $radius-default;
    border-bottom-right-radius: $radius-default;
    &__spacer {
      margin-top: 5px;
      margin-left: 10px;
      margin-right: 10px;
      border-top: 1px solid $color-iloq-gray;
    }
    &__entry {
      padding: 10px 40px;
      cursor: pointer;
      &:hover,
      &:focus {
        background: $color-iloq-gray-light;
      }
    }
    &__active {
      background: $color-iloq-gray-light;
    }
  }
}
</style>
